import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

import LangTab from "../../../components/tabs/langTab";
import { showLoader } from "../../../components/loader/loader";
import { langService } from "../../../jwt/_services";
import { FL_TITLE } from "../../../components/i18n/formLabels";
import { PH_TITLE } from "../../../components/i18n/placeHolders";

class ContactCategoryLangs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading            : false,
            editMode           : this.props.editMode,
            disableInputs      : this.props.disableInputs,
            contactCategory    : this.props.contactCategory,
            langChilds         : [],
            langContacCategory : this.props.editMode ? this.props.contactCategory?.langs : []
        }

        this.setForm           = this.setForm.bind(this);
        this.combineLangChilds = this.combineLangChilds.bind(this);
        this.getLangChilds     = this.getLangChilds.bind(this);
        this.getFormulary      = this.getFormulary.bind(this);
        this.updateParent      = this.updateParent.bind(this);
        this.onTitleChange      = this.onTitleChange.bind(this);
    }

    // ----------------------------------
    // Establece las opciones de idioma
    // ----------------------------------
    componentDidMount() {
        let langChilds = [];
        this.setState({loading: true});

        langService.getAll()
            .then(langOptions => {
                if (langOptions) {
                    langOptions.map((lang, _) => {
                        const langChild = {
                            id   : '',
                            lang : lang,
                            title : '',
                        };
                        langChilds.push(langChild);
                        this.setState({langChilds, loading: false});
                    });
                }
            })
            .then( () => {
                if (this.state.editMode){
                    langChilds = this.combineLangChilds(this.state.langChilds, this.state.langContacCategory);
                    this.setState({ langChilds });
                }
            }).finally(()=>this.setState({loading: false}));
    }

    setForm(editMode, showList, data) {
        this.props.setForm(editMode, showList, data)
    }

    getLangChilds(){
        const langChilds = this.combineLangChilds(this.state?.langChilds, this.state.langContacCategory);
        return (langChilds ? langChilds : (this.state?.langChilds ? this.state?.langChilds : []));
    }

    changeDisabledInput(option, langs){
        this.setState({disableInputs : option, langContacCategory : langs});
        this.getLangChilds(); // Refresh component
    }

    resetForm(){
        let langOption = [];
        this.state.langChilds.map((langC) => {
            const langChild = {
                id   : '',
                lang : langC.lang,
                title : '',
            };
            langOption.push(langChild);
        });
        this.setState({langChilds: langOption, langContacCategory: [], disableInputs : false});
        this.getLangChilds();
    }

    combineLangChilds(langOptions, langChilds){
        try {
            if (langOptions && langChilds && langOptions.length > 0 && langChilds.length > 0){
                langOptions.map((child, index) => {
                    const langIndex = langChilds.findIndex(n => n?.lang === child?.lang?.id);

                    if (langIndex !== -1) {
                        // significa que si lo encontro
                        langOptions[index] = {
                            id   : langChilds[langIndex]?.id,
                            lang : child.lang,
                            title : langChilds[langIndex]?.title,
                        }
                    }
                });

                return langOptions;
            }
        } catch (e) {
            return e.message;
        }
    }

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    onTitleChange(value, index, lang){
        const langIndex = this.state.langChilds.findIndex(n => n.lang.id === lang.id);
        let langChilds = this.state.langChilds.slice();

        if(langIndex === -1)
            return;

        langChilds[langIndex] = {
            id   : langChilds[langIndex].id,
            lang : langChilds[langIndex].lang,
            uid  : langChilds[langIndex].uid,
            title : value,
        }

        this.updateParent(langChilds);
    }

    // Le envia la información al componente padre
    updateParent(langChilds){
        this.props.updateItem(langChilds);
        this.setState({
            langChilds : langChilds,
            langContacCategory : langChilds
        });
    }

    getFormulary(child, index, disableInputs){
        return (
            <FormGroup>
                <Label>{FL_TITLE}</Label>
                <Input
                    type="text"
                    name="title"
                    placeholder={ PH_TITLE }
                    value={ child.title }
                    onChange={ e => this.onTitleChange(e.target.value, index, child.lang ) }
                    disabled={ disableInputs }
                />
            </FormGroup>
        );
    }

    render() {
        return (
            <Row>
                {this.state.loading ? showLoader() : null}
                <Col md="12">
                    <LangTab
                        key={"LangTabId"}
                        langChilds={this.state.langChilds}
                        getLangChilds={this.getLangChilds}
                        getFormulary={this.getFormulary}
                        disableInputs={this.state.disableInputs}
                    />
                </Col>
            </Row>
        );
    }
}

export default ContactCategoryLangs